export function postToPreview(frame: HTMLIFrameElement | null, _origin: string, message: Record<string, unknown>) {
  // The preview iframe is sandboxed WITHOUT allow-same-origin so hostile bundle
  // JS cannot reach this app's storage or token. That gives the frame an opaque
  // origin, which only a "*" targetOrigin can address. Safe here: the receiver
  // (the editor bridge) authenticates every message by the parent's real origin
  // plus the "protopal-editor" source tag, so "*" widens nothing that matters.
  frame?.contentWindow?.postMessage({ source: "protopal-editor", ...message }, "*");
}

export function pageLabel(path: string) {
  if (!path || path === "/" || path === "home" || path === "index.html") return "Home";
  return path.replace(/^\/|\/index\.html$|\.html$/g, "").split("/").filter(Boolean).map((word) => word[0]?.toUpperCase() + word.slice(1).replace(/[-_]/g, " ")).join(" / ");
}

export function pageHref(path: string) {
  if (!path || path === "home" || path === "index.html") return "/";
  return `/${path.replace(/^\/|index\.html$/g, "")}`;
}

export function pageFile(path: string) {
  if (!path || path === "/" || path === "home") return "index.html";
  if (path.endsWith(".html")) return path.replace(/^\//, "");
  return `${path.replace(/^\/|\/$/g, "")}/index.html`;
}

export function samePage(a?: string | null, b?: string | null) {
  return pageFile(a ?? "") === pageFile(b ?? "");
}

export function toHexColor(value: string | undefined, fallback: string) {
  if (!value) return fallback;
  const trimmed = value.trim();
  if (/^#[0-9a-f]{6}$/i.test(trimmed)) return trimmed.toLowerCase();
  if (/^#[0-9a-f]{3}$/i.test(trimmed)) {
    const [, r, g, b] = trimmed;
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  const rgb = trimmed.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!rgb) return fallback;
  return `#${[rgb[1], rgb[2], rgb[3]].map((part) => Number(part).toString(16).padStart(2, "0")).join("")}`;
}

export function contrastRatio(a: string, b: string) {
  const lum = (hex: string) => {
    if (!/^#[0-9a-f]{6}$/i.test(hex)) return null;
    const rgb = [1, 3, 5].map((i) => Number.parseInt(hex.slice(i, i + 2), 16) / 255)
      .map((v) => v <= .03928 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4);
    return .2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2];
  };
  const one = lum(a);
  const two = lum(b);
  return one === null || two === null ? null : (Math.max(one, two) + .05) / (Math.min(one, two) + .05);
}
